import React from 'react';
import { Link } from 'react-router-dom';
import { DataTable, Button, Modal } from 'carbon-components-react';
// import { account } from 'carbon-icons';
import { Account16 } from '@carbon/icons-react';
import './DetailInformationAsset.css';
import funcTranslateHelper from '../../../../i18next/funcTranslateHelper';
import moment from 'moment';
import { URL_TRAZER } from '../../../../constants/api_urls';

export default function DetailInformationAsset ({ open, setOpen, asset }) {
  const {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    TableHeader,
    TableToolbar,
    TableToolbarContent
  } = DataTable;

  const handleCloseAndOpen = () => {
    setOpen(false);
  };

  const CustomLink = ({ children, href, ...other }) => (
    <Link to={`asset/${asset.assetId}`} {...other}>
      {funcTranslateHelper('DetailInformationAsset.Ver Historico')}
    </Link>
  );

  const TrazerLink = ({ children, href, ...other }) => (
    <a
      target='_blank'
      rel='noopener noreferrer'
      href={`${URL_TRAZER}asset/${asset.assetId}`} {...other}
    >
      {funcTranslateHelper('DetailInformationAsset.Trazer')}
    </a>
  );

  function parseObject (key, value) {
    value['0'] = key;
    return value;
  }

  function parserTime (key, value) {
    const time = ['tx_creationTimeStamp', 'tx_timeStamp'];
    if (time.includes(key)) {
      return moment(
        new Date(value.replace(' +0000 UTC', 'Z').replace(' ', 'T'))
      ).format('DD/MM/YYYY HH:mm:ss A Z UTC');
    } else if (Array.isArray(value)) {
      return value.join(', ');
    } else {
      return funcTranslateHelper(value);
    }
  }

  const RenderTableBody = (asset, obj) =>
    Object.entries(asset).map(([key, value], i) => {
      if (typeof value === 'object' && Array.isArray(value) === false) {
        const keyValueArray = parseObject(key, value);
        return RenderTableBody(keyValueArray, asset);
      }

      return key === '0' ? (
        <TableRow key={i}>
          <TableCell style={{ fontWeight: '900' }}>{value}</TableCell>
          <TableCell />
        </TableRow>
      ) : typeof obj === 'object' ? (
        <TableRow key={i}>
          <TableCell style={{ paddingLeft: '50px' }}>
            {funcTranslateHelper(key)}
          </TableCell>
          <TableCell>{parserTime(key, value)}</TableCell>
        </TableRow>
      ) : (
        <TableRow key={i}>
          <TableCell>{funcTranslateHelper(key)}</TableCell>
          <TableCell>{parserTime(key, value)}</TableCell>
        </TableRow>
      );
    });

  return (
    <div>
      <div id='scroll' className='scroll-table'>
        <Modal
          open={open}
          focusTrap
          onRequestSubmit={handleCloseAndOpen}
          onSecondarySubmit={() => alert('historico')}
          passiveModal
          onRequestClose={handleCloseAndOpen}
          primaryButtonText='Cerrar ventana'
          secondaryButtonText='Histórico del asset'
          aria-labelledby='alert-dialog-slide-title'
          aria-describedby='alert-dialog-slide-description'
          className='bx--modal-container-asset-detail'
        >
          <DataTable
            style={{ width: '1000px' }}
            rows={[]}
            headers={[]}
            render={({ rows, headers, getHeaderProps }) => (
              <TableContainer
                title={`${asset.name}`}
                description={`${asset.assetType ? asset.assetType : ''}`}
              >
                <TableToolbar>
                  {/* make sure to apply getBatchActionProps so that the bar renders */}
                  <TableToolbarContent>
                    <Button
                      as={CustomLink}
                      kind='primary'
                      size='small'
                      renderIcon={Account16}
                    >
                      Ver Histórico
                    </Button>
                    <Button
                      as={TrazerLink}
                      kind='secondary'
                      size='small'
                      renderIcon={Account16}
                    >
                      Ver en Trazer
                    </Button>
                  </TableToolbarContent>
                </TableToolbar>
                <Table>
                  <TableHead>
                    <TableRow>
                      {[
                        'DetailInformationAsset.Nombre',
                        'DetailInformationAsset.Valor'
                      ].map((header, i) => (
                        <TableHeader key={i}>
                          {funcTranslateHelper(header)}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>{RenderTableBody(asset)}</TableBody>
                </Table>
              </TableContainer>
            )}
          />
        </Modal>
      </div>
    </div>
  );
}
